import { render, staticRenderFns } from "./MediaAccreditationPrintManager.vue?vue&type=template&id=60ace915&scoped=true&"
import script from "./MediaAccreditationPrintManager.vue?vue&type=script&lang=js&"
export * from "./MediaAccreditationPrintManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ace915",
  null
  
)

export default component.exports